import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IEmailRequest } from "../../utils/types/models";

export default createEntityReducer<IEmailRequest>(Endpoint.EmailRequests, Endpoint.EmailRequestsList);
